import * as d3 from "d3-scale-chromatic";
export const colorSchemes = {
    Blues: d3.interpolateBlues,
    Greens: d3.interpolateGreens,
    Greys: d3.interpolateGreys,
    Oranges: d3.interpolateOranges,
    Purples: d3.interpolatePurples,
    Reds: d3.interpolateReds,
    BlueGreen: d3.interpolateBuGn,
    BluePurple: d3.interpolateBuPu,
    GreenBlue: d3.interpolateGnBu,
    OrangeRed: d3.interpolateOrRd,
    PurpleBlueGreen: d3.interpolatePuBuGn,
    PurpleBlue: d3.interpolatePuBu,
    PurpleRed: d3.interpolatePuRd,
    RedPurple: d3.interpolateRdPu,
    YellowGreenBlue: d3.interpolateYlGnBu,
    YellowGreen: d3.interpolateYlGn,
    YellowOrangeBrown: d3.interpolateYlOrBr,
    YellowOrangeRed: d3.interpolateYlOrRd,
    Cividis: d3.interpolateCividis,
    Viridis: d3.interpolateViridis,
    Inferno: d3.interpolateInferno,
    Magma: d3.interpolateMagma,
    Plasma: d3.interpolatePlasma,
    Warm: d3.interpolateWarm,
    Cool: d3.interpolateCool,
    Cubehelix: d3.interpolateCubehelixDefault,
    Turbo: d3.interpolateTurbo,
    BrownBlueGreen: d3.interpolateBrBG,
    PurpleRedGreen: d3.interpolatePRGn,
    PinkYellowGreen: d3.interpolatePiYG,
    PurpleOrange: d3.interpolatePuOr,
    RedBlue: d3.interpolateRdBu,
    RedGrey: d3.interpolateRdGy,
    RedYellowBlue: d3.interpolateRdYlBu,
    RedYellowGreen: d3.interpolateRdYlGn,
    Spectral: d3.interpolateSpectral,
    Rainbow: d3.interpolateRainbow,
    Sinebow: d3.interpolateSinebow,
};
export var colorSchemesNames;
(function (colorSchemesNames) {
    colorSchemesNames["BLUES"] = "Blues";
    colorSchemesNames["GREENS"] = "Greens";
    colorSchemesNames["GREYS"] = "Greys";
    colorSchemesNames["ORANGES"] = "Oranges";
    colorSchemesNames["PURPLES"] = "Purples";
    colorSchemesNames["REDS"] = "Reds";
    colorSchemesNames["BLUEGREEN"] = "BlueGreen";
    colorSchemesNames["BLUEPURPLE"] = "BluePurple";
    colorSchemesNames["GREENBLUE"] = "GreenBlue";
    colorSchemesNames["ORANGERED"] = "OrangeRed";
    colorSchemesNames["PURPLEBLUEGREEN"] = "PurpleBlueGreen";
    colorSchemesNames["PURPLEBLUE"] = "PurpleBlue";
    colorSchemesNames["PURPLERED"] = "PurpleRed";
    colorSchemesNames["REDPURPLE"] = "RedPurple";
    colorSchemesNames["YELLOWGREENBLUE"] = "YellowGreenBlue";
    colorSchemesNames["YELLOWGREEN"] = "YellowGreen";
    colorSchemesNames["YELLOWORANGEBROWN"] = "YellowOrangeBrown";
    colorSchemesNames["YELLOWORANGERED"] = "YellowOrangeRed";
    colorSchemesNames["CIVIDIS"] = "Cividis";
    colorSchemesNames["VIRIDIS"] = "Viridis";
    colorSchemesNames["INFERNO"] = "Inferno";
    colorSchemesNames["MAGMA"] = "Magma";
    colorSchemesNames["PLASMA"] = "Plasma";
    colorSchemesNames["WARM"] = "Warm";
    colorSchemesNames["COOL"] = "Cool";
    colorSchemesNames["CUBEHELIX"] = "Cubehelix";
    colorSchemesNames["TURBO"] = "Turbo";
    colorSchemesNames["BROWNBLUEGREEN"] = "BrownBlueGreen";
    colorSchemesNames["PURPLEREDGREEN"] = "PurpleRedGreen";
    colorSchemesNames["PINKYELLOWGREEN"] = "PinkYellowGreen";
    colorSchemesNames["PURPLEORANGE"] = "PurpleOrange";
    colorSchemesNames["REDBLUE"] = "RedBlue";
    colorSchemesNames["REDGREY"] = "RedGrey";
    colorSchemesNames["REDYELLOWBLUE"] = "RedYellowBlue";
    colorSchemesNames["REDYELLOWGREEN"] = "RedYellowGreen";
    colorSchemesNames["SPECTRAL"] = "Spectral";
    colorSchemesNames["RAINBOW"] = "Rainbow";
    colorSchemesNames["SINEBOW"] = "Sinebow";
})(colorSchemesNames || (colorSchemesNames = {}));
//# sourceMappingURL=colorSchemes.js.map